import React from 'react';
import { connect } from '../../../../redux/store';
import {
  DefaultHeaderComponent,
  DefaultBodyComponent,
  standardConnectMapper,
  DefaultToggleButton,
} from '../ActivityNode';
import {
  openModalForm,
  Card,
  CardRow,
  Utils,
  C,
} from '@kineticdata/bundle-common';
import { selectActivityDetailsFromState } from '../../../../redux/modules/submission';
import { I18n } from '@kineticdata/react';
import classNames from 'classnames';

export const MediaSanitationNode = connect((state, props) => ({
  ...standardConnectMapper({
    state,
    props,
    dataListExcludes: [
      'Status',
      'Link',
      'InternalLink',
      'DownloadInternalLink',
      'Reference Id',
      'Data',
    ],
  }),
  allowMediaSanitationEdit:
    props.data.Status === 'Completed' &&
    Utils.isMemberOf(state.app.profile, 'ACCESS-DCFG Equipment'),
  ...selectActivityDetailsFromState(props.activity.id, state),
}))(
  ({
    className,
    submission,
    activity,
    data,
    activityDetailsLoading,
    activityDetails,
    dataList,
    hasDataList,
    allowMediaSanitationEdit,
    link,
    isDownload,
    approval,
    action,
    appLocation,
    location,
    servicesKapp,
    isOpen,
    toggle,
    isMobile,
  }) => {
    const hasBody = dataList.length > 0 || approval || action;
    return (
      <li className={classNames('activity__row', className)}>
        <div className="card-wrapper">
          <DefaultToggleButton
            isOpen={!hasBody || isOpen}
            toggle={hasBody ? toggle : undefined}
          />
          <Card>
            <DefaultHeaderComponent
              status={data.Status}
              title={activity.label}
              link={link}
              isDownload={isDownload}
              meta={[
                { label: 'Created', value: activity.createdAt, timeAgo: true },
                activity.createdAt !== activity.updatedAt && {
                  label: 'Updated',
                  value: activity.updatedAt,
                  timeAgo: true,
                },
              ].filter(Boolean)}
              isOpen={!hasBody || isOpen}
              toggle={hasBody ? toggle : undefined}
              isMobile={isMobile}
            />
            {hasBody && (
              <DefaultBodyComponent
                dataList={dataList.map(
                  d =>
                    d.label === 'Number of Drives' && activityDetails
                      ? { ...d, value: activityDetails.length }
                      : d,
                )}
                approval={approval}
                action={action}
                isOpen={isOpen}
                toggle={toggle}
                appLocation={appLocation}
                location={location}
              >
                {({ dataRow, approvalRow, actionRow, toggleMoreRow }) => (
                  <>
                    {dataRow}
                    {data['Data'] && (
                      <CardRow>
                        <pre>{data['Data']}</pre>
                      </CardRow>
                    )}
                    {activityDetails && (
                      <CardRow>
                        <pre>
                          {activityDetails.length > 0 ? (
                            <table className="w-100">
                              <thead>
                                <tr>
                                  <td>Make</td>
                                  <td>Model</td>
                                  <td>Type</td>
                                  <td>Serial Number</td>
                                  <td>Sanitation Type</td>
                                </tr>
                              </thead>
                              <tbody>
                                {activityDetails.map((record, i) => (
                                  <tr key={`record-${i}`}>
                                    <td>{record['Make']}</td>
                                    <td>{record['Model']}</td>
                                    <td>{record['Media Type']}</td>
                                    <td>{record['Serial Number']}</td>
                                    <td>{record['Destruction Type']}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          ) : (
                            <I18n>No Media Associated</I18n>
                          )}
                        </pre>
                      </CardRow>
                    )}
                    {allowMediaSanitationEdit && (
                      <CardRow>
                        <button
                          type="button"
                          className="btn btn-link pull-right"
                          onClick={() =>
                            openModalForm({
                              kappSlug: servicesKapp && servicesKapp.slug,
                              formSlug: C.FORM_SLUG_EDIT_MEDIA_SANITATION,
                              title: 'Edit Media Sanitation Data',
                              confirmationMessage:
                                'Your edit request has been submitted.',
                              values: {
                                'Request Submission Id': submission.id,
                                'Activity Id': activity.id,
                                'Record Edit': 'true',
                              },
                            })
                          }
                        >
                          Edit Media Sanitation Data
                        </button>
                      </CardRow>
                    )}
                    {approvalRow}
                    {actionRow}
                    {toggleMoreRow}
                  </>
                )}
              </DefaultBodyComponent>
            )}
          </Card>
        </div>
      </li>
    );
  },
);
